

import styled from "styled-components"
import PageTopTitle from "../../components/shared/PageTopTitle"
import { useState } from "react"
import { useSearchParams } from "react-router-dom"
import { useSelector } from "react-redux"
import { useEffect } from "react"
import { useDispatch } from "react-redux"
import { getKKK } from "../../features/adminSett/adminSettSlice"

const Container = styled.div`
width: 100%;

.wrapper{
    display: flex;
    flex-direction: column;
    width: 100%;

    .content{
      width: calc(100% - 60px);
      gap: 60px;
      margin: 30px;
    }

    .list{
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 15px;
    }
}
`


const KamyoonKullanimKilavuzu = () => {




  return (
    <Container>
    <div className="wrapper">
      <PageTopTitle title={"Kamyoon Kullanım Klavuzu"} position='sticky'/>
      <div className="content">
      
      </div>
    </div>
  </Container>
  )
}

export default KamyoonKullanimKilavuzu